<!-- <fgb-navigation-indicator></fgb-navigation-indicator> -->

<fgb-nav-bar></fgb-nav-bar>

<div id="main">
  <router-outlet></router-outlet>
</div>

<div class="d-lg-block d-none">
  <fgb-footer></fgb-footer>
</div>
